'use client'
import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { replaceSpacesWithPascalCase } from '../../../utils/utils'
import { fonts } from '../../../Theme/LegacyTheme'

interface AccordionDataItem {
  title: string
  content: React.ReactNode
  disabled?: boolean
  defaultExpanded?: boolean
}

interface CustomAccordionProps {
  accordionData: AccordionDataItem[]
}

const MuiAccordion: React.FC<CustomAccordionProps> = ({ accordionData }) => {
  return (
    <>
      {accordionData.map((item) => (
        <Accordion
          key={uuidv4()}
          disabled={item.disabled}
          defaultExpanded={item.defaultExpanded}
          id={`${replaceSpacesWithPascalCase(item.title)}Accordion`}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: (theme) => theme.palette.primary.main }} />}
            aria-controls={`accordion-${item.title}-content`}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: {
                  xs: '16px',
                  md: '18px'
                },
                marginBottom: 0,
                fontFamily: fonts.regular
              }}
            >
              {item.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography component="div">{item.content}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  )
}

export default MuiAccordion
